import { useCallback, useEffect, useState } from "react";
import { getOperationalLocations } from "../services/dashboard";

export const useOperationalBranchNames = (capability: "BRANCH" | "MORTUARY" = "BRANCH") => {
  const [branchOptions, setBranchOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchBranchNames = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getOperationalLocations(capability);
      const names = response?.status === 200 && Array.isArray(response.data)
        ? response.data.map((location: { branchName: string }) => location.branchName)
        : [];
      setBranchOptions(names);
    } finally {
      setLoading(false);
    }
  }, [capability]);

  useEffect(() => {
    void fetchBranchNames();
  }, [fetchBranchNames]);

  return { branchOptions, loading, fetchBranchNames };
};
